import { COUNTRY_OPTIONS } from './countries';
import { DEPARTAMENTO_CO_OPTIONS } from './departamentosCO';

const DOCUMENT_TYPE_OPTIONS = [
  { value: 'CC', label: 'Cédula de ciudadanía' },
  { value: 'TI', label: 'Tarjeta de identidad' },
  { value: 'CE', label: 'Cédula de extranjería' },
  { value: 'PPT', label: 'Permiso por Protección Temporal (PPT)' },
  { value: 'PEP_PERMISO', label: 'Permiso Especial de Permanencia' },
  { value: 'REGISTRO_CIVIL', label: 'Registro civil' },
  { value: 'NIT', label: 'NIT' },
];

const CIVIL_STATUS_OPTIONS = [
  { value: 'SOLTERO', label: 'Soltero(a)' },
  { value: 'CASADO', label: 'Casado(a)' },
  { value: 'UNION_LIBRE', label: 'Unión libre' },
  { value: 'SEPARADO', label: 'Separado(a)' },
  { value: 'DIVORCIADO', label: 'Divorciado(a)' },
  { value: 'VIUDO', label: 'Viudo(a)' },
  { value: 'OTRO', label: 'Otro' },
];

const GENDER_OPTIONS = [
  { value: 'MASCULINO', label: 'Masculino' },
  { value: 'FEMENINO', label: 'Femenino' },
  { value: 'OTRO', label: 'Otro' },
  { value: 'NO_ESPECIFICA', label: 'Prefiero no decirlo' },
];

const ESTRATO_OPTIONS = [
  { value: '1', label: 'Estrato 1' },
  { value: '2', label: 'Estrato 2' },
  { value: '3', label: 'Estrato 3' },
  { value: '4', label: 'Estrato 4' },
  { value: '5', label: 'Estrato 5' },
  { value: '6', label: 'Estrato 6' },
];

const NIVEL_ESTUDIOS_OPTIONS = [
  { value: 'NINGUNO', label: 'Ninguno' },
  { value: 'PRIMARIA', label: 'Primaria' },
  { value: 'SECUNDARIA', label: 'Secundaria / Bachillerato' },
  { value: 'TECNICO', label: 'Técnico' },
  { value: 'TECNOLOGO', label: 'Tecnólogo' },
  { value: 'PREGRADO', label: 'Pregrado / Profesional' },
  { value: 'ESPECIALIZACION', label: 'Especialización' },
  { value: 'MAESTRIA', label: 'Maestría' },
  { value: 'DOCTORADO', label: 'Doctorado' },
  { value: 'POSTDOCTORADO', label: 'Postdoctorado' },
];

const OCUPACION_OPTIONS = [
  { value: 'EMPLEADO', label: 'Empleado' },
  { value: 'INDEPENDIENTE', label: 'Independiente' },
  { value: 'EMPRESARIO', label: 'Empresario' },
  { value: 'ESTUDIANTE', label: 'Estudiante' },
  { value: 'HOGAR', label: 'Oficios del hogar' },
  { value: 'PENSIONADO', label: 'Pensionado' },
  { value: 'DESEMPLEADO', label: 'Desempleado' },
  { value: 'OTRO', label: 'Otro' },
];

const RIESGO_OPTIONS = [
  { value: 'BAJO', label: 'Bajo' },
  { value: 'MEDIO', label: 'Medio' },
  { value: 'ALTO', label: 'Alto' },
  { value: 'NO_DETERMINADO', label: 'Sin clasificar' },
];

export const ADDRESS_FIELD_NAMES = [
  'direccionViaTipo',
  'direccionViaNumero',
  'direccionViaLetra',
  'direccionBis',
  'direccionCuadrante',
  'direccionNumeroSecundario',
  'direccionLetraSecundaria',
  'direccionNumeroPlaca',
  'direccionComplemento',
];

export const OPTIONAL_ADDRESS_FIELDS = [
  'direccionViaLetra',
  'direccionBis',
  'direccionCuadrante',
  'direccionLetraSecundaria',
  'direccionComplemento',
];

const VIA_TIPO_OPTIONS = [
  { value: 'CALLE', label: 'Calle' },
  { value: 'CARRERA', label: 'Carrera' },
  { value: 'AVENIDA', label: 'Avenida' },
  { value: 'AVENIDA_CARRERA', label: 'Avenida Carrera' },
  { value: 'AVENIDA_CALLE', label: 'Avenida Calle' },
  { value: 'DIAGONAL', label: 'Diagonal' },
  { value: 'TRANSVERSAL', label: 'Transversal' },
  { value: 'CIRCULAR', label: 'Circular' },
  { value: 'AUTOPISTA', label: 'Autopista' },
  { value: 'CARRETERA', label: 'Carretera' },
  { value: 'PASAJE', label: 'Pasaje' },
  { value: 'VEREDA', label: 'Vereda' },
  { value: 'VIA', label: 'Vía' },
];

const CUADRANTE_OPTIONS = [
  { value: 'N', label: 'N' },
  { value: 'S', label: 'S' },
  { value: 'E', label: 'E' },
  { value: 'O', label: 'O' },
  { value: 'NE', label: 'NE' },
  { value: 'NO', label: 'NO' },
  { value: 'SE', label: 'SE' },
  { value: 'SO', label: 'SO' },
];

export const SECTION_CONFIG = [
  { id: 'datos-personales', label: 'Datos personales' },
  { id: 'contacto', label: 'Contacto' },
  { id: 'documento', label: 'Documento de identidad' },
  { id: 'nacionalidad', label: 'Nacionalidad y residencia' },
  { id: 'actividad', label: 'Actividad profesional' },
  { id: 'riesgo', label: 'Perfil de riesgo' },
];

export const ESTRATO_TO_BACKEND = {
  '1': 'E1',
  '2': 'E2',
  '3': 'E3',
  '4': 'E4',
  '5': 'E5',
  '6': 'E6',
};

export const ESTRATO_FROM_BACKEND = {
  E1: '1',
  E2: '2',
  E3: '3',
  E4: '4',
  E5: '5',
  E6: '6',
};

export const FIELD_CONFIG = [
  {
    name: 'genero',
    label: 'Género',
    type: 'text',
    section: 'datos-personales',
    options: GENDER_OPTIONS,
  },
  { name: 'primerNombre', label: 'Primer nombre', type: 'text', section: 'datos-personales', inputProps: { maxLength: 100 }, includeInFlow: false },
  { name: 'segundoNombre', label: 'Segundo nombre', type: 'text', section: 'datos-personales', inputProps: { maxLength: 100 }, includeInFlow: false },
  { name: 'primerApellido', label: 'Primer apellido', type: 'text', section: 'datos-personales', inputProps: { maxLength: 100 }, includeInFlow: false },
  { name: 'segundoApellido', label: 'Segundo apellido', type: 'text', section: 'datos-personales', inputProps: { maxLength: 100 }, includeInFlow: false },
  { name: 'fechaNacimiento', label: 'Fecha de nacimiento', type: 'date', section: 'datos-personales' },
  {
    name: 'estadoCivil',
    label: 'Estado civil',
    type: 'text',
    section: 'datos-personales',
    options: CIVIL_STATUS_OPTIONS,
  },
  {
    name: 'personasCargo',
    label: 'Personas a cargo',
    type: 'number',
    section: 'datos-personales',
    inputProps: { min: 0, step: 1 },
  },
  {
    name: 'numeroHijos',
    label: 'Número de hijos',
    type: 'number',
    section: 'datos-personales',
    inputProps: { min: 0, step: 1 },
  },

  { name: 'celular', label: 'Celular', type: 'text', section: 'contacto', inputProps: { maxLength: 20, inputMode: 'tel', placeholder: '+573001112233' } },
  { name: 'telefonoFijo', label: 'Teléfono fijo', type: 'text', section: 'contacto', inputProps: { maxLength: 20, inputMode: 'tel', placeholder: '+5716010000' } },
  { name: 'correoElectronico', label: 'Correo electrónico', type: 'text', section: 'contacto', inputProps: { type: 'email', maxLength: 254 } },

  {
    name: 'tipoDocumento',
    label: 'Tipo de documento',
    type: 'text',
    section: 'documento',
    options: DOCUMENT_TYPE_OPTIONS,
  },
  { name: 'numeroDocumento', label: 'Número de documento', type: 'text', section: 'documento', inputProps: { maxLength: 30, inputMode: 'text' } },
  { name: 'fechaExpedicion', label: 'Fecha de expedición', type: 'date', section: 'documento' },
  { name: 'paisExpedicion', label: 'País de expedición', type: 'text', section: 'documento', options: COUNTRY_OPTIONS },
  { name: 'departamentoExpedicion', label: 'Departamento de expedición', type: 'text', section: 'documento', options: DEPARTAMENTO_CO_OPTIONS },
  {
    name: 'ciudadExpedicionId',
    label: 'Ciudad de expedición',
    type: 'text',
    section: 'documento',
    options: [],
  },
  {
    name: 'ciudadExpedicionOtra',
    label: 'Ciudad de expedición (otro país)',
    type: 'text',
    section: 'documento',
    inputProps: { maxLength: 100, placeholder: 'Ingresa la ciudad de expedición' },
  },
  { name: 'nacidoEnColombia', label: '¿Nacido en Colombia?', type: 'boolean', section: 'documento' },
  { name: 'paisNacimiento', label: 'País de nacimiento', type: 'text', section: 'documento', options: COUNTRY_OPTIONS },
  { name: 'departamentoNacimiento', label: 'Departamento de nacimiento', type: 'text', section: 'documento', options: DEPARTAMENTO_CO_OPTIONS },
  {
    name: 'ciudadNacimientoId',
    label: 'Ciudad de nacimiento',
    type: 'text',
    section: 'documento',
    options: [],
  },

  { name: 'otraNacionalidad', label: '¿Tienes otra nacionalidad?', type: 'boolean', section: 'nacionalidad' },
  { name: 'paisOtraNacionalidad', label: 'País de la otra nacionalidad', type: 'text', section: 'nacionalidad', options: COUNTRY_OPTIONS },
  { name: 'viveEnColombia', label: '¿Vives en Colombia?', type: 'boolean', section: 'nacionalidad' },
  { name: 'paisResidencia', label: 'País de residencia', type: 'text', section: 'nacionalidad', options: COUNTRY_OPTIONS },
  {
    name: 'ciudadResidenciaId',
    label: 'Ciudad de residencia',
    type: 'text',
    section: 'nacionalidad',
    options: [],
  },
  {
    name: 'direccionViaTipo',
    label: 'Tipo de vía',
    type: 'text',
    section: 'nacionalidad',
    options: VIA_TIPO_OPTIONS,
    meta: { addressPart: true, hideInForm: true },
  },
  {
    name: 'direccionViaNumero',
    label: 'Número de vía',
    type: 'text',
    section: 'nacionalidad',
    inputProps: { maxLength: 4, inputMode: 'numeric', pattern: '[0-9]*' },
    meta: { addressPart: true, hideInForm: true },
  },
  {
    name: 'direccionViaLetra',
    label: 'Letra de vía (opcional)',
    type: 'text',
    section: 'nacionalidad',
    inputProps: { maxLength: 2, placeholder: 'Ej: A' },
    meta: { addressPart: true, hideInForm: true },
  },
  {
    name: 'direccionBis',
    label: '¿Incluye BIS?',
    type: 'boolean',
    section: 'nacionalidad',
    meta: { addressPart: true, hideInForm: true },
  },
  {
    name: 'direccionCuadrante',
    label: 'Cuadrante (opcional)',
    type: 'text',
    section: 'nacionalidad',
    options: CUADRANTE_OPTIONS,
    meta: { addressPart: true, hideInForm: true },
  },
  {
    name: 'direccionNumeroSecundario',
    label: 'Número secundario (#)',
    type: 'text',
    section: 'nacionalidad',
    inputProps: { maxLength: 4, inputMode: 'numeric', pattern: '[0-9]*' },
    meta: { addressPart: true, hideInForm: true },
  },
  {
    name: 'direccionLetraSecundaria',
    label: 'Letra secundaria (opcional)',
    type: 'text',
    section: 'nacionalidad',
    inputProps: { maxLength: 2, placeholder: 'Ej: B' },
    meta: { addressPart: true, hideInForm: true },
  },
  {
    name: 'direccionNumeroPlaca',
    label: 'Número placa (-)',
    type: 'text',
    section: 'nacionalidad',
    inputProps: { maxLength: 4, inputMode: 'numeric', pattern: '[0-9]*' },
    meta: { addressPart: true, hideInForm: true },
  },
  {
    name: 'direccionComplemento',
    label: 'Complemento (opcional)',
    type: 'text',
    section: 'nacionalidad',
    inputProps: { maxLength: 100, placeholder: 'Apartamento, torre, interior...' },
    meta: { addressPart: true, hideInForm: true },
  },
  {
    name: 'direccionResidencia',
    label: 'Dirección formateada',
    type: 'text',
    section: 'nacionalidad',
    inputProps: { maxLength: 200, readOnly: true },
    meta: { addressGroupRoot: true },
  },
  {
    name: 'estrato',
    label: 'Estrato',
    type: 'text',
    section: 'nacionalidad',
    options: ESTRATO_OPTIONS,
  },

  {
    name: 'nivelEstudios',
    label: 'Nivel de estudios',
    type: 'text',
    section: 'actividad',
    options: NIVEL_ESTUDIOS_OPTIONS,
  },
  {
    name: 'profesionId',
    label: 'Profesión',
    type: 'text',
    section: 'actividad',
    options: [],
    meta: { catalog: 'profesiones' },
  },
  { name: 'profesionDetalle', label: 'Detalle de la profesión', type: 'text', section: 'actividad', inputProps: { maxLength: 200 } },
  { name: 'contratistaEstado', label: '¿Eres contratista del Estado?', type: 'boolean', section: 'actividad' },
  {
    name: 'ocupacion',
    label: 'Ocupación',
    type: 'text',
    section: 'actividad',
    options: OCUPACION_OPTIONS,
  },
  {
    name: 'campoOcupacionId',
    label: 'Campo de ocupación',
    type: 'text',
    section: 'actividad',
    options: [],
    meta: { catalog: 'occupationFields' },
  },

  { name: 'pep', label: '¿Eres PEP?', type: 'boolean', section: 'riesgo' },
  { name: 'pepDetalle', label: 'Detalle PEP', type: 'text', section: 'riesgo', inputProps: { maxLength: 200, placeholder: 'Describe tu relación PEP (opcional)' } },
  {
    name: 'riesgo',
    label: 'Nivel de riesgo',
    type: 'text',
    section: 'riesgo',
    options: RIESGO_OPTIONS,
  },
];

export const createEmptyProfileForm = () =>
  FIELD_CONFIG.reduce((acc, field) => {
    acc[field.name] = '';
    return acc;
  }, {});

export const mapUsuarioToFormValues = (data) => {
  const base = createEmptyProfileForm();
  if (!data) {
    return base;
  }

  FIELD_CONFIG.forEach((field) => {
    const rawValue = data[field.name];
    if (rawValue === undefined || rawValue === null) {
      return;
    }

    if (field.type === 'date') {
      base[field.name] = String(rawValue).slice(0, 10);
      return;
    }

    if (field.type === 'boolean') {
      base[field.name] = rawValue ? 'true' : 'false';
      return;
    }

    if (field.name === 'estrato') {
      const key = String(rawValue);
      base[field.name] = ESTRATO_FROM_BACKEND[key] ?? key;
      return;
    }

    base[field.name] = `${rawValue}`;
  });

  return base;
};

export const getSectionFields = (sectionId, { flowOnly = false } = {}) =>
  FIELD_CONFIG.filter(
    (field) =>
      field.section === sectionId && (!flowOnly || field.includeInFlow !== false),
  );

export const FLOW_SECTIONS = SECTION_CONFIG.map((section) => ({
  ...section,
  fields: getSectionFields(section.id, { flowOnly: true }),
})).filter((section) => section.fields.length > 0);

export const FLOW_SECTION_IDS = FLOW_SECTIONS.map((section) => section.id);

export const FLOW_TOTAL_STEPS = FLOW_SECTIONS.length;

export const formatAddressPreview = (values = {}) => {
  const tipo = values?.direccionViaTipo;
  const numero = values?.direccionViaNumero;
  const numeroSecundario = values?.direccionNumeroSecundario;
  const placa = values?.direccionNumeroPlaca;

  if (!tipo || !numero || !numeroSecundario || !placa) {
    return values?.direccionResidencia ?? '';
  }

  const viaLetra = values?.direccionViaLetra
    ? String(values.direccionViaLetra).toUpperCase()
    : '';
  const bis =
    values?.direccionBis === true || values?.direccionBis === 'true' ? 'Bis' : '';
  const cuadrante = values?.direccionCuadrante ?? '';
  const letraSecundaria = values?.direccionLetraSecundaria
    ? String(values.direccionLetraSecundaria).toUpperCase()
    : '';
  const complemento = values?.direccionComplemento
    ? String(values.direccionComplemento).trim()
    : '';

  const primaryParts = [
    String(tipo).replace(/_/g, ' '),
    String(numero),
    viaLetra,
    bis,
    cuadrante,
  ].filter((part) => String(part).trim().length > 0);

  const secondary = `${numeroSecundario}${letraSecundaria}`;

  let result = `${primaryParts.join(' ').replace(/\s+/g, ' ').trim()} # ${secondary}`;
  result += ` - ${placa}`;
  if (complemento.length > 0) {
    result += ` ${complemento}`;
  }

  return result.trim();
};

export const buildUsuarioPayload = (formValues, options = {}) => {
  const { fields = FIELD_CONFIG, skipEmpty = false } = options;
  const payload = {};

  fields.forEach((field) => {
    const rawOriginal = formValues[field.name];
    const raw = typeof rawOriginal === 'string' ? rawOriginal.trim() : rawOriginal;

    if (raw === '' || raw === undefined || raw === null) {
      if (skipEmpty) {
        return;
      }
      payload[field.name] = null;
      return;
    }

    if (field.type === 'number') {
      const parsed = typeof raw === 'number' ? raw : Number.parseInt(raw, 10);
      payload[field.name] = Number.isNaN(parsed) ? null : parsed;
      return;
    }

    if (field.type === 'boolean') {
      if (raw === 'true' || raw === true) {
        payload[field.name] = true;
        return;
      }
      if (raw === 'false' || raw === false) {
        payload[field.name] = false;
        return;
      }
      if (!skipEmpty) {
        payload[field.name] = null;
      }
      return;
    }

    if (field.type === 'date') {
      if (typeof raw === 'string' && raw.length > 0) {
        const isoCandidate =
          /^\d{4}-\d{2}-\d{2}$/.test(raw)
            ? `${raw}T00:00:00.000Z`
            : raw;
        const parsed = new Date(isoCandidate);
        if (!Number.isNaN(parsed.getTime())) {
          payload[field.name] = parsed.toISOString();
          return;
        }
      }
      if (!skipEmpty) {
        payload[field.name] = null;
      }
      return;
    }

    if (field.name === 'estrato') {
      payload[field.name] = ESTRATO_TO_BACKEND[String(raw)] ?? null;
      return;
    }

    payload[field.name] = raw;
  });

  return payload;
};

export const buildSectionPayload = (
  formValues,
  sectionId,
  { skipEmpty = false, flowOnly = true } = {},
) => {
  const fields = getSectionFields(sectionId, { flowOnly });
  return buildUsuarioPayload(formValues, { fields, skipEmpty });
};

export const hasDataForSection = (
  formValues,
  sectionId,
  { flowOnly = true } = {},
) => {
  const fields = getSectionFields(sectionId, { flowOnly });
  return fields.some((field) => {
    const rawOriginal = formValues[field.name];
    if (field.type === 'boolean') {
      return rawOriginal === 'true' || rawOriginal === 'false';
    }
    if (typeof rawOriginal === 'string') {
      return rawOriginal.trim().length > 0;
    }
    return rawOriginal !== undefined && rawOriginal !== null;
  });
};
